import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import FooterToolBar from '@/components/tool/FooterToolBar.vue';
import StandardTableVue from '@/components/table/StandardTable.vue';
import { getDeployData, saveDeployData, sync60Erp as _sync60Erp, syncElastic } from '@/services/systemsetting';
export default {
  components: {
    FooterToolBar: FooterToolBar,
    StandardTableVue: StandardTableVue
  },
  i18n: require("../i18n-basucSettings"),
  data: function data() {
    var columnsTemplature = [{
      title: this.$t('emailNumber'),
      scopedSlots: {
        customRender: 'num'
      }
    }, {
      title: this.$t('deploy.transport'),
      dataIndex: 'transportTitle'
    }, {
      title: this.$t('deploy.transportId'),
      dataIndex: 'id'
    }, {
      title: this.$t('deploy.temId'),
      dataIndex: 'erpTransportid'
    }];
    var columnsTransport = [{
      title: this.$t('emailNumber'),
      scopedSlots: {
        customRender: 'num'
      }
    }, {
      title: this.$t('deploy.transportCp'),
      dataIndex: 'transportationName'
    }, {
      title: this.$t('deploy.transportCpId'),
      dataIndex: 'id'
    }, {
      title: this.$t('deploy.erpTransportId'),
      dataIndex: 'erpTransportationId'
    }];
    var columnsUrl = [{
      title: this.$t('emailNumber'),
      scopedSlots: {
        customRender: 'num'
      },
      width: '50px'
    }, {
      title: this.$t('deploy.type'),
      dataIndex: 'remark',
      width: '280px'
    }, {
      title: 'URL',
      dataIndex: 'url'
    }];
    return {
      loadingSave: false,
      syncShow: false,
      syncLoading: false,
      form: {
        siteDomainName: '',
        aliInvalidMailSync: '0',
        fbStatus: '0',
        googleStatus: '0',
        ysDataSync: '0',
        // siteInterfacePrefix:'',
        pictureDomainName: ''
      },
      rules: {
        siteDomainName: [{
          required: true,
          message: this.$t('deploy.rule1'),
          trigger: 'change'
        }],
        // siteInterfacePrefix:[{required:true, message:this.$t('deploy.rule2'),trigger:'change'}],
        pictureDomainName: [{
          required: true,
          message: this.$t('deploy.rule3'),
          trigger: 'change'
        }]
      },
      columnsTemplature: columnsTemplature,
      dataTemperature: [],
      columnsTransport: columnsTransport,
      dataTransport: [],
      columnsUrl: columnsUrl,
      dataUrl: [],
      syncContent: false,
      showSpinning: false,
      syncErpShow: false,
      // 同步得意先60天卖上传票 开始同步
      syncErpLoading: false,
      // 同步得意先60天卖上传票 同步中
      syncErpContent: false // 同步得意先60天卖上传票 同步是否成功
    };
  },
  mounted: function mounted() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.showSpinning = true;
              _context.n = 1;
              return getDeployData();
            case 1:
              res = _context.v;
              if (res.data.code == 200) {
                _this.form = {
                  siteDomainName: res.data.data.siteDomain,
                  aliInvalidMailSync: res.data.data.aliInvalidEmailStatus,
                  fbStatus: res.data.data.faceBookStatisticsStatus,
                  googleStatus: res.data.data.googleStatisticsStatus,
                  ysDataSync: res.data.data.syncDataFromErpStatus,
                  // siteInterfacePrefix:res.data.data.siteApiPrefix,
                  pictureDomainName: res.data.data.imgDomain
                };
                _this.dataTransport = res.data.data.yySysTransportationList;
                _this.dataTemperature = res.data.data.yyTransportList;
                _this.dataUrl = res.data.data.yyUrlSettingList;
                _this.showSpinning = false;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    changeYs: function changeYs(e) {
      this.form.ysDataSync = e.target.value;
    },
    changeGoogle: function changeGoogle(e) {
      this.form.googleStatus = e.target.value;
    },
    changeFb: function changeFb(e) {
      this.form.fbStatus = e.target.value;
    },
    changeAli: function changeAli(e) {
      this.form.aliInvalidMailSync = e.target.value;
    },
    save: function save() {
      var _this2 = this;
      this.$refs.formModel.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var params, res;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!valid) {
                  _context2.n = 4;
                  break;
                }
                _this2.loadingSave = true;
                params = {
                  "siteDomain": _this2.form.siteDomainName,
                  // "siteApiPrefix": this.form.siteInterfacePrefix,
                  "imgDomain": _this2.form.pictureDomainName,
                  "syncDataFromErpStatus": _this2.form.ysDataSync,
                  "googleStatisticsStatus": _this2.form.googleStatus,
                  "faceBookStatisticsStatus": _this2.form.fbStatus,
                  "aliInvalidEmailStatus": _this2.form.aliInvalidMailSync
                };
                _context2.p = 1;
                _context2.n = 2;
                return saveDeployData(params);
              case 2:
                res = _context2.v;
                if (res.data.code == 200) {
                  _this2.loadingSave = false;
                  _this2.$message.success(_this2.$t('deploy.saveSuccess'));
                }
              case 3:
                _context2.p = 3;
                _this2.loadingSave = false;
                return _context2.f(3);
              case 4:
                return _context2.a(2);
            }
          }, _callee2, null, [[1,, 3, 4]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    sync: function sync() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.syncLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return syncElastic();
            case 2:
              res = _context3.v;
              if (res.data.data) {
                _this3.syncShow = true;
                _this3.syncLoading = false;
                _this3.syncContent = true;
              } else {
                _this3.syncShow = true;
                _this3.syncLoading = false;
                _this3.syncContent = false;
              }
            case 3:
              _context3.p = 3;
              _this3.syncLoading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[1,, 3, 4]]);
      }))();
    },
    sync60Erp: function sync60Erp() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this4.syncErpLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return _sync60Erp();
            case 2:
              res = _context4.v;
              if (res.data.data) {
                _this4.syncErpShow = true;
                _this4.syncErpLoading = false;
                _this4.syncErpContent = true;
              } else {
                _this4.syncErpShow = true;
                _this4.syncErpLoading = false;
                _this4.syncErpContent = false;
              }
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t = _context4.v;
              console.log(_t);
              _this4.syncErpShow = true;
              _this4.syncErpLoading = false;
              _this4.syncErpContent = false;
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 3]]);
      }))();
    }
  }
};